export const FETCH_CUSTOMERS_REQUEST = 'FETCH_CUSTOMERS_REQUEST';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAILURE = 'FETCH_CUSTOMERS_FAILURE';

export const FETCH_CUSTOMER_STATS_REQUEST = 'FETCH_CUSTOMER_STATS_REQUEST';
export const FETCH_CUSTOMER_STATS_SUCCESS = 'FETCH_CUSTOMER_STATS_SUCCESS';
export const FETCH_CUSTOMER_STATS_FAILURE = 'FETCH_CUSTOMER_STATS_FAILURE';

export const FETCH_CUSTOMER_BY_ID_REQUEST = 'FETCH_CUSTOMER_BY_ID_REQUEST';
export const FETCH_CUSTOMER_BY_ID_SUCCESS = 'FETCH_CUSTOMER_BY_ID_SUCCESS';
export const FETCH_CUSTOMER_BY_ID_FAILURE = 'FETCH_CUSTOMER_BY_ID_FAILURE';

export const FETCH_CUSTOMER_ORDERS_REQUEST = 'FETCH_CUSTOMER_ORDERS_REQUEST';
export const FETCH_CUSTOMER_ORDERS_SUCCESS = 'FETCH_CUSTOMER_ORDERS_SUCCESS';
export const FETCH_CUSTOMER_ORDERS_FAILURE = 'FETCH_CUSTOMER_ORDERS_FAILURE';
